var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4068_13537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7564 10.852C31.5353 9.48737 29.7224 8.70479 27.3137 8.50423C28.0865 6.46715 29.6143 4.25704 31.903 1.87192C32.5244 1.22501 33.1693 0.605631 33.8241 -0.00195312H26.7907C25.7328 1.08147 24.7497 2.20816 23.8471 3.384C22.1345 5.61968 20.823 7.93007 19.9126 10.3191C19.0022 12.7082 18.6994 15.0716 19.0101 17.4115C19.2912 19.5312 20.2881 21.295 21.9988 22.7048C23.7115 24.1127 25.6994 24.6691 27.9646 24.3702C30.0862 24.0891 31.8499 23.0921 33.2598 21.3815C34.6696 19.6708 35.2241 17.6809 34.9233 15.4157C34.7011 13.7326 33.9794 12.2107 32.7564 10.85V10.852Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8644 10.852C12.6433 9.48737 10.8304 8.70479 8.42166 8.50423C9.19441 6.46715 10.7222 4.25704 13.011 1.87192C13.6323 1.22501 14.2773 0.605631 14.9321 -0.00195312H7.89863C6.84076 1.08147 5.85762 2.20816 4.95509 3.384C3.24245 5.61968 1.93093 7.93007 1.02054 10.3191C0.108178 12.7101 -0.192665 15.0736 0.11801 17.4155C0.399189 19.5351 1.3961 21.2989 3.10677 22.7087C4.81941 24.1166 6.80734 24.673 9.0725 24.3742C11.1941 24.093 12.9579 23.0961 14.3677 21.3854C15.7776 19.6747 16.3321 17.6848 16.0312 15.4197C15.809 13.7365 15.0874 12.2146 13.8644 10.8539V10.852Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4068_13537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24.4508,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotes);
export default __webpack_public_path__ + "static/media/icon-quotes.32dbfb7d052897f1de3d2dae37416f3e.svg";
export { ForwardRef as ReactComponent };